import React, { useState } from 'react';

export default function Footer() {
  const [activeModal, setActiveModal] = useState(null);

  const closeModal = () => setActiveModal(null);

  const styles = {
    footer: {
      backgroundColor: '#0B1F3A',
      color: '#ffffff',
      padding: '40px 20px',
      marginTop: '50px',
      display: 'flex',
      flexDirection: 'row',
      flexWrap: 'wrap',
      justifyContent: 'space-around',
      alignItems: 'flex-start',
      fontFamily: 'Inter, sans-serif',
    },
    column: {
      margin: '10px',
      minWidth: '250px',
    },
    title: {
      color: '#C9A35A',
      fontSize: '18px',
      marginBottom: '15px',
      fontWeight: 'bold',
    },
    text: {
      fontSize: '14px',
      color: '#95a5a6',
      lineHeight: '1.6',
    },
    linkButton: {
      background: 'none',
      border: 'none',
      color: '#95a5a6',
      textDecoration: 'underline',
      cursor: 'pointer',
      padding: '5px 0',
      display: 'block',
      fontSize: '14px',
      textAlign: 'left',
    },
    overlay: {
      position: 'fixed',
      top: 0,
      left: 0,
      width: '100vw',
      height: '100vh',
      backgroundColor: 'rgba(0, 0, 0, 0.7)',
      display: 'flex',
      justifyContent: 'center',
      alignItems: 'center',
      zIndex: 1000,
    },
    modal: {
      backgroundColor: '#fff',
      color: '#2c3e50',
      width: '90%',
      maxWidth: '800px',
      maxHeight: '80vh',
      borderRadius: '8px',
      padding: '40px',
      overflowY: 'auto',
      position: 'relative',
      boxShadow: '0 4px 20px rgba(0,0,0,0.2)',
    },
    closeBtn: {
      position: 'absolute',
      top: '15px',
      right: '20px',
      background: '#c0392b',
      color: 'white',
      border: 'none',
      borderRadius: '50%',
      width: '30px',
      height: '30px',
      cursor: 'pointer',
      fontWeight: 'bold',
      fontSize: '16px',
    }
  };

  return (
    <>
      <footer style={styles.footer}>
        <div style={styles.column}>
          <div style={styles.title}>Audit Cyber Pro</div>
          <p style={styles.text}>
            La plateforme SaaS d'audit cyber et de conformité de référence pour les entreprises.
          </p>
        </div>

        <div style={styles.column}>
          <div style={styles.title}>Support client</div>
          <p style={styles.text}>
            Notre service client est disponible :<br /><br />
                        📞 06 61 41 62 21<br />
            📧 contact@auditcyberpro.com<br />
            🕘 Du lundi au vendredi<br />
            de 9h à 18h (heure de Paris)
          </p>
        </div>

        <div style={styles.column}>
          <div style={styles.title}>Informations légales</div>
          <button style={styles.linkButton} onClick={() => setActiveModal('cgv')}>Conditions Générales (CGV/CGU)</button>
          <button style={styles.linkButton} onClick={() => setActiveModal('privacy')}>Politique de Confidentialité</button>
          <button style={styles.linkButton} onClick={() => setActiveModal('legal')}>Mentions Légales</button>
        </div>
      </footer>

      {activeModal && (
        <div style={styles.overlay} onClick={closeModal}>
          <div style={styles.modal} onClick={(e) => e.stopPropagation()}>
            <button style={styles.closeBtn} onClick={closeModal}>X</button>
            {activeModal === 'cgv' && <CGVContent />}
            {activeModal === 'privacy' && <PrivacyContent />}
            {activeModal === 'legal' && <LegalContent />}
          </div>
        </div>
      )}
    </>
  );
}

// ==========================================
// 1. CGV / CGU COMPLETES
// ==========================================
function CGVContent() {
  return (
    <div style={{ lineHeight: '1.6', fontFamily: 'sans-serif' }}>
      <h2 style={{ color: '#0B1F3A', borderBottom: '2px solid #C9A35A', paddingBottom: '10px' }}>
        CONDITIONS GÉNÉRALES DE VENTE ET D’UTILISATION (CGV/CGU) – B2B
      </h2>

      <h3 style={{ color: '#0B1F3A' }}>1. Objet</h3>
      <p>Les présentes CGV/CGU définissent les conditions d’accès et d’utilisation de la plateforme SaaS « Audit Cyber Pro » (ci-après le « Service »), ainsi que les modalités de souscription, de facturation et de responsabilité. Ce Service est exclusivement réservé à une clientèle de professionnels (B2B) agissant dans le cadre de leur activité.</p>

      <h3 style={{ color: '#0B1F3A' }}>2. Identification du Prestataire</h3>
      <p>Jean-Luc Cadignan, entrepreneur individuel, exerçant sous le nom commercial « Audit Cyber Pro ».<br/>
      Adresse : 18 boulevard Garibaldi, 75015 Paris<br/>
      SIRET : 983 460 353 00029<br/>
      Email : contact@auditcyberpro.com (ci-après le « Prestataire »)</p>

      <h3 style={{ color: '#0B1F3A' }}>3. Définitions</h3>
      <ul>
        <li><strong>Service :</strong> plateforme SaaS d’audit cyber et de conformité.</li>
        <li><strong>Utilisateur :</strong> toute personne accédant au Service.</li>
        <li><strong>Client :</strong> professionnel (personne physique ou morale) ayant souscrit un abonnement ou un achat unique.</li>
        <li><strong>Données Client :</strong> données fournies et exploitées par le Client sur le Service.</li>
      </ul>

      <h3 style={{ color: '#0B1F3A' }}>4. Description du Service</h3>
      <p>Le Service permet notamment :</p>
      <ul>
        <li>L’évaluation automatisée du niveau de cybersécurité.</li>
        <li>L’analyse de conformité réglementaire au regard de référentiels tels que le RGPD, la directive NIS2 et la norme ISO 27001.</li>
        <li>La génération de rapports et de plans d’action.</li>
        <li>La création de tâches opérationnelles.</li>
      </ul>
      <p>Le Service repose en partie sur des technologies d’intelligence artificielle.</p>

      <h3 style={{ color: '#0B1F3A' }}>5. Accès au Service</h3>
      <p>L’accès nécessite la création d’un compte et la fourniture d’informations exactes. Le Client est seul et unique responsable de la confidentialité et de la sécurité de ses identifiants de connexion.</p>

      <h3 style={{ color: '#0B1F3A' }}>Article 6. Conditions financières</h3>
      <h4>6.1 Abonnements et Tarifs</h4>
      <p>Le Service est proposé sous forme d’abonnement (mensuel ou annuel) ou d'achat unique.<br/>
      Les prix sont fermes, définitifs et indiqués en euros, nets de taxes. En effet, conformément à l'article 293 B du Code Général des Impôts (CGI), la TVA est non applicable (franchise en base de TVA).<br/>
      Toutefois, si le Prestataire venait à dépasser les seuils légaux et devenait redevable de la TVA à l'avenir, les prix affichés et facturés seraient automatiquement majorés du taux de TVA en vigueur au jour de la transaction.</p>

      <h4>6.2 Paiement</h4>
      <ul>
        <li>Le paiement s'effectue en ligne via un prestataire sécurisé (ex : Stripe).</li>
        <li>L'abonnement fait l'objet d'un renouvellement automatique à l'issue de chaque période, sauf résiliation par le Client.</li>
      </ul>

      <h4>6.3 Retard ou défaut de paiement</h4>
      <p>En cas de défaut de paiement, le Prestataire se réserve le droit de suspendre l’accès au Service de plein droit et sans préavis.</p>

      <h3 style={{ color: '#0B1F3A' }}>7. Droit de rétractation</h3>
      <p>Le Service étant conçu et commercialisé exclusivement à destination de professionnels dans le cadre de leur activité commerciale, industrielle, artisanale ou libérale, le droit de rétractation prévu par le Code de la consommation ne s'applique pas. Toute souscription est ferme et définitive.</p>

      <h3 style={{ color: '#0B1F3A' }}>8. Résiliation</h3>
      <p>Le Client peut résilier son abonnement à tout moment via son espace client.</p>
      <ul>
        <li>La résiliation prendra effet à la fin de la période de facturation en cours.</li>
        <li>Aucun remboursement partiel pour les périodes entamées ne sera effectué. Le Prestataire se réserve le droit de résilier unilatéralement le compte d'un Client en cas de violation grave des présentes CGV/CGU.</li>
      </ul>

      <h3 style={{ color: '#0B1F3A' }}>9. Obligations du Client</h3>
      <p>Le Client s’engage à :</p>
      <ul>
        <li>Utiliser le Service de manière loyale et conforme à sa destination.</li>
        <li>Ne pas détourner le Service à des fins illicites ou malveillantes.</li>
        <li>Ne pas tenter de porter atteinte à la sécurité ou à l'intégrité de la plateforme.</li>
      </ul>

      <h3 style={{ color: '#0B1F3A' }}>10. Données et conformité RGPD</h3>
      <p>Le Prestataire agit en qualité de sous-traitant au sens du RGPD.</p>
      <ul>
        <li><strong>10.1 Traitement :</strong> Les données sont traitées uniquement pour les besoins et l’exécution du Service.</li>
        <li><strong>10.2 Hébergement :</strong> Les données sont hébergées sur des infrastructures sécurisées situées sur le territoire de l'Union Européenne.</li>
        <li><strong>10.3 Responsabilité du Client :</strong> Le Client demeure le Responsable de Traitement des données personnelles qu’il soumet à la plateforme et garantit avoir obtenu les consentements nécessaires.</li>
      </ul>

      <h3 style={{ color: '#0B1F3A' }}>11. Intelligence artificielle</h3>
      <p>Le Service intègre des systèmes d’Intelligence Artificielle (IA). Le Client est expressément informé et reconnaît que :</p>
      <ul>
        <li>Les résultats générés sont automatisés et peuvent contenir des approximations ou des inexactitudes (hallucinations).</li>
        <li>Une validation et une analyse humaines par le Client sont indispensables.</li>
        <li>Le Service constitue un outil d'aide à la décision et ne remplace en aucun cas un audit juridique, technique ou humain exhaustif.</li>
      </ul>

      <h3 style={{ color: '#0B1F3A' }}>12. SLA – Disponibilité du Service</h3>
      <p>Le Prestataire s’efforce d’assurer une disponibilité du Service de 99 % du temps. Sont expressément exclus de cet engagement : les opérations de maintenance programmées, les cas de force majeure et les défaillances de tiers (fournisseur d'accès, hébergeur). Aucune indemnisation ou pénalité n’est due en cas d'indisponibilité.</p>

      <h3 style={{ color: '#0B1F3A' }}>13. Sécurité</h3>
      <p>Le Prestataire met en œuvre des mesures techniques raisonnables (chiffrement, contrôle d’accès, surveillance) pour protéger les données. Toutefois, s'agissant d'une obligation de moyens, aucune sécurité absolue ne peut être garantie face aux cybermenaces.</p>

      <h3 style={{ color: '#0B1F3A' }}>14. Propriété intellectuelle</h3>
      <p>La plateforme, le code source, les algorithmes, les modèles de scoring, les textes et les éléments visuels sont la propriété exclusive du Prestataire. Toute reproduction, décompilation ou exploitation non expressément autorisée est strictement interdite.</p>

      <h3 style={{ color: '#0B1F3A' }}>15. Limitation de responsabilité</h3>
      <ul>
        <li><strong>15.1 Principe :</strong> Le Service est fourni « en l’état ».</li>
        <li><strong>15.2 Exclusions :</strong> Le Prestataire ne saurait être tenu responsable des décisions métiers prises par le Client suite à l'utilisation de l'outil, ni des pertes de données, pertes de chiffre d'affaires, ou de tout autre dommage indirect.</li>
        <li><strong>15.3 Plafond :</strong> Dans tous les cas, la responsabilité pécuniaire totale du Prestataire est strictement limitée au montant effectivement payé par le Client pour l'utilisation du Service au cours des douze (12) derniers mois précédant le fait générateur du litige.</li>
      </ul>

      <h3 style={{ color: '#0B1F3A' }}>16. Force majeure</h3>
      <p>La responsabilité du Prestataire ne pourra être recherchée en cas d'inexécution de ses obligations due à un événement de force majeure (tel que défini par l'article 1218 du Code civil).</p>

      <h3 style={{ color: '#0B1F3A' }}>17. Sous-traitance</h3>
      <p>Le Prestataire est autorisé à recourir à des prestataires tiers ou sous-traitants pour l'exécution d'une partie des Services (hébergement, modules d'IA, passerelle de paiement).</p>

      <h3 style={{ color: '#0B1F3A' }}>18. Modification des CGV/CGU</h3>
      <p>Le Prestataire se réserve le droit de modifier les présentes CGV/CGU à tout moment. Le Client en sera informé. La version applicable est celle en vigueur au moment de l'utilisation du Service ou du renouvellement de l'abonnement.</p>

      <h3 style={{ color: '#0B1F3A' }}>19. Droit applicable</h3>
      <p>Les présentes CGV/CGU sont régies et soumises au droit français.</p>

      <h3 style={{ color: '#0B1F3A' }}>20. Litiges</h3>
      <p>En cas de litige relatif à l'interprétation ou l'exécution des présentes, les parties s'engagent à rechercher préalablement une solution amiable. À défaut de résolution amiable, compétence expresse et exclusive est attribuée au Tribunal de Commerce de Paris, nonobstant pluralité de défendeurs ou appel en garantie.</p>
    </div>
  );
}

// ==========================================
// 2. POLITIQUE DE CONFIDENTIALITE COMPLETE
// ==========================================
function PrivacyContent() {
  return (
    <div style={{ lineHeight: '1.6', fontFamily: 'sans-serif' }}>
      <h2 style={{ color: '#0B1F3A', borderBottom: '2px solid #C9A35A', paddingBottom: '10px' }}>
        Politique de Confidentialité et Protection des Données (RGPD)
      </h2>

      <h3 style={{ color: '#0B1F3A' }}>1. Introduction</h3>
      <p>La présente politique de confidentialité décrit la manière dont « Audit Cyber Pro » collecte, utilise et protège les données personnelles des utilisateurs de sa plateforme SaaS. Elle s’applique à l’ensemble des traitements effectués dans le cadre de l’utilisation du Service.</p>

      <h3 style={{ color: '#0B1F3A' }}>2. Rôles et responsabilités (Responsable de traitement et Sous-traitant)</h3>
      <p>Afin de respecter la réglementation (RGPD), il est précisé que le Prestataire agit sous deux casquettes distinctes :</p>
      <ul>
        <li><strong>En tant que Responsable de traitement :</strong> pour les données de facturation, de gestion de compte et de prospection commerciale vous concernant directement (Client).</li>
        <li><strong>En tant que Sous-traitant :</strong> pour les données (y compris les données personnelles éventuelles de vos collaborateurs) que vous saisissez ou analysez à travers nos outils d'audit. Le Client demeure le Responsable de traitement de ces données.</li>
      </ul>

      <h3 style={{ color: '#0B1F3A' }}>3. Identité du Responsable du traitement</h3>
      <p>Jean-Luc Cadignan, Entrepreneur individuel<br/>
      Nom commercial : Audit Cyber Pro<br/>
      Adresse : 18 boulevard Garibaldi, 75015 Paris<br/>
      Email : contact@auditcyberpro.com</p>

      <h3 style={{ color: '#0B1F3A' }}>4. Données collectées</h3>
      <h4>4.1 Données fournies par l’utilisateur</h4>
      <ul>
        <li>Nom, prénom et adresse email</li>
        <li>Informations de connexion</li>
        <li>Données saisies ou importées dans le cadre des audits</li>
        <li>Informations de facturation</li>
      </ul>
      <h4>4.2 Données collectées automatiquement</h4>
      <ul>
        <li>Adresse IP et logs techniques</li>
        <li>Données de navigation</li>
        <li>Cookies techniques nécessaires au fonctionnement</li>
        <li>Données statistiques et analytiques collectées via <strong>Google Analytics</strong> afin de mesurer l’audience du site, analyser la navigation des utilisateurs et améliorer l’expérience utilisateur.</li>
      </ul>
      <h4>4.3 Données générées</h4>
      <ul>
        <li>Scores d’audit et rapports</li>
        <li>Recommandations et tâches générées</li>
      </ul>

      <h3 style={{ color: '#0B1F3A' }}>5. Finalités des traitements</h3>
      <p>Les données sont traitées pour :</p>
      <ul>
        <li>La création et la gestion des comptes clients.</li>
        <li>L’exécution du Service et des audits, notamment l'évaluation de la conformité au regard de référentiels tels que le RGPD, la directive NIS2 et la norme ISO 27001.</li>
        <li>La génération des rapports, analyses et tâches.</li>
        <li>La gestion administrative et la facturation.</li>
        <li>L’amélioration continue du Service.</li>
        <li>L’analyse de fréquentation et des performances du site via Google Analytics.</li>
        <li>La sécurité de la plateforme et la prévention des fraudes.</li>
      </ul>

      <h3 style={{ color: '#0B1F3A' }}>6. Base légale</h3>
      <p>Les traitements reposent sur :</p>
      <ul>
        <li>L’exécution du contrat (accès et utilisation du Service).</li>
        <li>Le respect d'une obligation légale (conservation des factures).</li>
        <li>L’intérêt légitime (sécurité des systèmes, amélioration de l'outil).</li>
        <li>Le consentement (pour les cookies non essentiels, notamment les cookies analytiques Google Analytics, le cas échéant).</li>
      </ul>

      <h3 style={{ color: '#0B1F3A' }}>7. Durée de conservation</h3>
      <ul>
        <li><strong>Compte utilisateur et données associées :</strong> conservées pendant la durée d'utilisation du Service, puis pendant 3 ans (36 mois) à compter de la fin de la relation commerciale (ou de la dernière connexion) à des fins d'animation commerciale, sauf demande de suppression.</li>
        <li><strong>Données d’audit (mode Sous-traitant) :</strong> conservées tant que le compte est actif ou jusqu'à leur suppression par le Client.</li>
        <li><strong>Données de facturation :</strong> 10 ans (obligation légale et comptable).</li>
        <li><strong>Logs techniques de connexion :</strong> 12 mois maximum.</li>
        <li><strong>Données analytiques Google Analytics :</strong> conservées conformément aux durées définies par Google et aux paramètres configurés sur la plateforme.</li>
      </ul>

      <h3 style={{ color: '#0B1F3A' }}>8. Hébergement et Sécurité</h3>
      <p>Nous accordons une importance primordiale à la souveraineté et à la sécurité de vos données :</p>
      <ul>
        <li><strong>Hébergement backend et coffre-fort de données :</strong> L'ensemble de vos données, y compris les preuves téléchargées et les résultats d'audits, sont hébergés et stockés de manière sécurisée en <strong>France</strong>, sur les serveurs de notre partenaire cloud souverain <strong>Scaleway</strong>.</li>
        <li><strong>Hébergement applicatif :</strong> L'ensemble de la plateforme (interface web, API et base de données) est hébergé sur un serveur privé dédié loué auprès d'<strong>OVHcloud</strong>, opérateur d'infrastructure souverain français, situé en France.</li>
      </ul>
      <p>Le Prestataire met en œuvre des mesures techniques et organisationnelles rigoureuses : chiffrement des données en transit et au repos, contrôle des accès, et surveillance continue. Toutefois, s'agissant d'une obligation de moyens, aucune méthode de transmission ou de stockage n’étant totalement infaillible, le Prestataire ne peut garantir une sécurité absolue face aux cyberattaques.</p>

      <h3 style={{ color: '#0B1F3A' }}>9. Partage des données et Sous-traitants</h3>
      <p>Les données peuvent être transmises de manière sécurisée aux sous-traitants techniques suivants, strictement pour l'exécution du Service :</p>
      <ul>
        <li><strong>Hébergement, base de données et infrastructure :</strong> OVHcloud (France)</li>
        <li><strong>Intelligence Artificielle (fournisseur par défaut) :</strong> Mistral AI (France / Union Européenne), via API sécurisée B2B</li>
        <li><strong>Intelligence Artificielle (option activable par le Client) :</strong> OpenAI (États-Unis), via API sécurisée B2B</li>
        <li><strong>Coffre-fort de données souverain :</strong> Scaleway (France)</li>
        <li><strong>Paiement sécurisé :</strong> Stripe</li>
        <li><strong>Analyse d’audience et statistiques :</strong> Google Analytics</li>
      </ul>
      <p>Ces prestataires sont contractuellement tenus de protéger vos données conformément au RGPD. Aucune donnée personnelle n’est vendue ou cédée à des tiers.</p>

      <h3 style={{ color: '#0B1F3A' }}>10. Transferts hors Union Européenne</h3>
      <p>Certains de nos prestataires techniques peuvent traiter des données en dehors de l'Union Européenne. C'est notamment le cas lorsque le Client choisit, depuis les paramètres de son compte, d'utiliser OpenAI (États-Unis) plutôt que Mistral AI comme fournisseur d'intelligence artificielle. Dans ce cas, le Prestataire s'assure que des garanties appropriées sont mises en place (telles que les Clauses Contractuelles Types de la Commission Européenne).</p>

      <h3 style={{ color: '#0B1F3A' }}>11. Intelligence Artificielle (IA) et confidentialité</h3>
      <p>Le Service utilise, selon le fournisseur configuré par le Client dans ses paramètres, l'API de Mistral AI (France / Union Européenne, fournisseur par défaut) ou l'API d'OpenAI (États-Unis, disponible en option) pour analyser les réponses, générer des recommandations et produire des rapports.</p>
      <ul>
        <li><strong>Confidentialité et protection des données :</strong> Conformément aux politiques B2B respectives de Mistral AI et d'OpenAI concernant leurs API, les données (inputs) que vous soumettez à l'outil ne sont pas utilisées pour entraîner leurs modèles publics respectifs. Vos données d'audit restent strictement confidentielles.</li>
        <li><strong>Choix du fournisseur :</strong> Mistral AI est le fournisseur activé par défaut sur tous les comptes. Le Client peut, à tout moment, depuis la page « Paramètres » de son espace client, choisir de basculer vers OpenAI.</li>
        <li><strong>Limites technologiques :</strong> Les utilisateurs reconnaissent que les résultats générés sont automatisés et qu'une validation humaine par le Client reste indispensable.</li>
      </ul>

      <h3 style={{ color: '#0B1F3A' }}>12. Droits des utilisateurs</h3>
      <p>Conformément au RGPD, vous disposez des droits suivants sur vos données personnelles :</p>
      <ul>
        <li>Droit d’accès, de rectification et d’effacement.</li>
        <li>Droit à la limitation du traitement et à la portabilité de vos données.</li>
        <li>Droit d’opposition au traitement.</li>
      </ul>
      <p>Pour exercer vos droits, contactez-nous à : <strong>contact@auditcyberpro.com</strong></p>

      <h3 style={{ color: '#0B1F3A' }}>13. Cookies</h3>
      <p>La plateforme utilise principalement des cookies strictement nécessaires au fonctionnement technique (maintien de session, sécurité). Des cookies analytiques, notamment via Google Analytics, peuvent également être utilisés afin de mesurer l’audience et améliorer les performances du site. Ces cookies ne seront déposés qu’avec votre consentement explicite préalable, conformément à la réglementation applicable.</p>

      <h3 style={{ color: '#0B1F3A' }}>14. Modification de la politique</h3>
      <p>La présente politique peut être modifiée à tout moment pour s'adapter aux évolutions légales ou techniques. La version applicable est celle en vigueur et accessible sur le site lors de votre utilisation.</p>

      <h3 style={{ color: '#0B1F3A' }}>15. Autorité de contrôle</h3>
      <p>Si vous estimez que vos droits ne sont pas respectés, vous pouvez introduire une réclamation auprès de la Commission Nationale de l’Informatique et des Libertés : CNIL</p>

      <h3 style={{ color: '#0B1F3A' }}>16. Contact</h3>
      <p>Pour toute question relative à la protection de vos données personnelles ou à l'exercice de vos droits :<br/>
      Email : <strong>contact@auditcyberpro.com</strong></p>
    </div>
  );
}

// ==========================================
// 3. MENTIONS LEGALES COMPLETES
// ==========================================
function LegalContent() {
  return (
    <div style={{ lineHeight: '1.6', fontFamily: 'sans-serif' }}>
      <h2 style={{ color: '#0B1F3A', borderBottom: '2px solid #C9A35A', paddingBottom: '10px' }}>
        MENTIONS LÉGALES
      </h2>

      <h3 style={{ color: '#0B1F3A' }}>1. Éditeur du site</h3>
      <p>Le site internet « Audit Cyber Pro » ainsi que la plateforme SaaS associée sont édités par :<br/>
      Jean-Luc Cadignan, agissant en qualité d’Entrepreneur Individuel,<br/>
      exerçant sous le nom commercial « Audit Cyber Pro ».</p>
      <p><strong>Siège social :</strong> 18 boulevard Garibaldi, 75015 Paris, France<br/>
      <strong>SIRET :</strong> 983 460 353 00029<br/>
      <strong>TVA intracommunautaire :</strong> 👉 TVA non applicable – article 293 B du Code général des impôts</p>
      <p><strong>Contact :</strong><br/>
      Email : contact@auditcyberpro.com<br/>
            Téléphone : 06 61 41 62 21</p>

      <h3 style={{ color: '#0B1F3A' }}>2. Directeur de la publication</h3>
      <p>Le Directeur de la publication est : Jean-Luc Cadignan</p>

      <h3 style={{ color: '#0B1F3A' }}>3. Hébergement</h3>
      <p>L’infrastructure technique du site et de la plateforme SaaS est assurée par nos prestataires cloud :</p>

      <p><strong>Hébergement applicatif (interface web, API et base de données)</strong><br/>
      OVH SAS<br/>
      2 rue Kellermann, 59100 Roubaix<br/>
      France</p>
      <p><strong>Coffre-fort de données (preuves et résultats d'audits)</strong><br/>
      Scaleway SAS<br/>
      8 rue de la Ville l'Evêque, 75008 Paris<br/>
      France</p>

      <p>👉 Les données sensibles (preuves, PDF, résultats d'audits) sont hébergées sur des serveurs localisés en France (Scaleway).</p>

      <h3 style={{ color: '#0B1F3A' }}>4. Assurance Responsabilité Civile Professionnelle</h3>
      <p>L'activité est couverte par une assurance Responsabilité Civile Professionnelle souscrite auprès de :</p>
      <p><strong>Hiscox</strong><br/>
      Adresse postale : Hiscox Direct - TSA 49007, 60477 Compiègne Cedex, France<br/>
      Téléphone : 01 78 41 58 41</p>
      <p>Hiscox SA<br/>
      Siège social : 35 avenue Monterey, L-2163 Luxembourg, Luxembourg<br/>
      Numéro d'enregistrement au Luxembourg : B217018 — Capital social : 91 730 000 euros<br/>
      R.C.S. Paris 833 546 989 — N° TVA intracommunautaire : FR88833546989</p>

      <h3 style={{ color: '#0B1F3A' }}>5. Propriété intellectuelle</h3>
      <p>L’ensemble du site et de la plateforme SaaS « Audit Cyber Pro » (structure, textes, logos, éléments graphiques, code, algorithmes, rapports générés) est protégé par le droit de la propriété intellectuelle.<br/>
      Toute reproduction, représentation, modification ou exploitation, totale ou partielle, sans autorisation écrite préalable est interdite.<br/>
      Toute violation constitue une contrefaçon au sens des articles L.335-2 et suivants du Code de la propriété intellectuelle.</p>

      <h3 style={{ color: '#0B1F3A' }}>6. Données personnelles</h3>
      <p>Pour toute information relative à la collecte et au traitement des données personnelles, ainsi qu’à l’exercice de vos droits (accès, rectification, suppression), veuillez consulter notre <strong>Politique de Confidentialité</strong>.</p>

      <h3 style={{ color: '#0B1F3A' }}>7. Responsabilité</h3>
      <p>L’éditeur s’efforce de fournir des informations fiables et à jour. Toutefois :</p>
      <ul>
        <li>les informations sont fournies à titre indicatif</li>
        <li>le service repose sur des analyses automatisées</li>
        <li>aucune garantie d’exactitude ou d’exhaustivité n’est donnée</li>
      </ul>
      <p>L’utilisateur est seul responsable de l’utilisation des informations et des recommandations fournies.</p>

      <h3 style={{ color: '#0B1F3A' }}>8. Droit applicable</h3>
      <p>Le site est soumis au droit français.</p>

      <h3 style={{ color: '#0B1F3A' }}>9. Litiges</h3>
      <p>En cas de litige, une solution amiable sera recherchée en priorité. À défaut, les tribunaux compétents du ressort de Paris seront seuls compétents, sauf disposition légale contraire.</p>
    </div>
  );
}